import { FieldPath, UseFormSetValue } from 'react-hook-form';

import { FileDropzone2 } from '../../../../components/FileDropzone/FileDropzone2';
import { useFeatureFlags } from '../../../../helpers/hooks/useFeatureFlags';
import {
  ACCEPTED_FILE_UPLOAD_TYPES,
  HEIC_ACCEPTED_FILE_UPLOAD_TYPES,
} from '../../constants/constants';
import { SuggestedWaterFormState } from '../../types/SuggestedWaterForm';

interface FileUploadFieldProps {
  name: FieldPath<SuggestedWaterFormState>;
  setValue: UseFormSetValue<SuggestedWaterFormState>;
}

export const FileUploadField = ({ name, setValue }: FileUploadFieldProps) => {
  const handleUpload = (uploadedFiles: File[]): void => {
    setValue(name, uploadedFiles);
  };

  const handleClear = (clearedFiles: File[]): void => {
    setValue(name, clearedFiles);
  };

  const featureflags = useFeatureFlags(['heic']);
  const isHeicFeatureFlag = featureflags.heic;

  if (isHeicFeatureFlag) {
    return (
      <>
        <FileDropzone2
          id="uploadedFiles"
          label="Images or documents"
          description="Any file that supports your suggested changes"
          onUpload={handleUpload}
          multiple
          acceptedFileTypes={HEIC_ACCEPTED_FILE_UPLOAD_TYPES}
          onClear={handleClear}
        />
      </>
    );
  }

  return (
    <>
      <FileDropzone2
        id="uploadedFiles"
        label="Images or documents"
        description="Any file that supports your suggested changes"
        onUpload={handleUpload}
        multiple
        acceptedFileTypes={ACCEPTED_FILE_UPLOAD_TYPES}
        onClear={handleClear}
      />
    </>
  );
};
